import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface SDividerProps extends HTMLAttributes<HTMLHRElement> {
  /** true면 수직 분할선, false면 수평 분할선 */
  vertical?: boolean;
}

/** SDivider — sd-divider 포팅. 색상은 `--sys-color-divider-default`. */
export const SDivider = forwardRef<HTMLHRElement, SDividerProps>(function SDivider(
  { vertical = false, className, style, ...rest },
  ref,
) {
  return (
    <hr
      ref={ref}
      aria-orientation={vertical ? 'vertical' : 'horizontal'}
      className={cn(
        'shrink-0 border-0',
        vertical ? 'inline-block h-auto w-px self-stretch' : 'block h-px w-full',
        className,
      )}
      style={{ backgroundColor: 'var(--sys-color-divider-default, #E1E1E1)', ...style }}
      {...rest}
    />
  );
});
